import { useTranslation } from 'react-i18next';
import Page from '@/components/Page';

const Agreement = () => {
  const { t } = useTranslation();

  return (
    <Page
      title={t('pages.agreement.title')}
    >
      <Page.Section>{t('pages.agreement.content')}</Page.Section>
    </Page>
  );
};

export default Agreement;
